export default "/fonts/Gotham-Book.woff?0ffd4a8c229fc2b4abac6434cf5c73f4";